import usFlag from "../assets/images/flags/us.jpg"
import arFlag from "../assets/images/flags/arabic-flag.jpg"

const languages = {
  eng: {
    label: "English",
    flag: usFlag,
  },
  arab: {
    label: "Arabic",
    flag: arFlag,
  },
}

export default languages
